"use strict";

define('view/notification.item',['require','exports','module','marionette','backbone.radio','../templates','../libs/route.helper','../libs/format/date'],function (require, exports, module) {
  var Mn = require('marionette');
  var Radio = require('backbone.radio');
  var Templates = require('../templates');
  var RouteHelper = require('../libs/route.helper');
  var dateFormatter = require('../libs/format/date');
  var AppChannel = Radio.channel('global');
  var NotificationItemView = Mn.ItemView.extend({
    template: Templates.IRB['notification.item'],
    options: {
      format: 'CALENDAR_TIME'
    },
    serializeData: function serializeData() {
      var config = AppChannel.request('get:config');
      var timezoneSettingModel = AppChannel.request('get:setting:model', config.IRB_TIMEZONE);
      var data = Mn.ItemView.prototype.serializeData.apply(this, arguments);
      if (timezoneSettingModel.get('value')) {
        data.studyLabel = this.model.get('studyLabel');
        data.principalInvestigator = this.model.get('principalInvestigator');
        data.time = dateFormatter(this.getOption('format'))(data.createDate);
        return data;
      } else {
        this.listenTo(timezoneSettingModel, 'change:value', function () {
          this.render();
        });
      }
    }
  });
  module.exports = NotificationItemView;
});

